import Link from 'next/link';
import StarRow from '@/components/ui/StarRow';
import ChevronIcon from '@/components/ui/icons/ChevronIcon';
import GoogleIcon from '@/components/ui/icons/GoogleIcon';
import { COPY } from '@/lib/copy';

type Props = {
  showRating?: boolean;
  averageRating?: number;
  showReviewsLink?: boolean;
  googleReviewsUrl?: string;
  hasCarousel: boolean;
  onPrev: () => void;
  onNext: () => void;
};

export default function ReviewsControls({
  showRating,
  averageRating,
  showReviewsLink,
  googleReviewsUrl,
  hasCarousel,
  onPrev,
  onNext,
}: Props) {
  return (
    <div className="flex items-center gap-4 shrink-0 flex-wrap">
      {showRating && averageRating != null && (
        <div
          className="flex items-center gap-3"
          aria-label={COPY.reviews.ratingLabel(
            averageRating.toFixed(1).replace('.', ','),
          )}
        >
          <span className="font-serif text-[1.6rem] font-semibold text-text leading-none">
            {averageRating.toFixed(1).replace('.', ',')}
          </span>
          <StarRow count={5} size={15} />
          <span className="font-sans text-[0.7rem] text-color-text-light">
            {COPY.reviews.googleLabel}
          </span>
          {showReviewsLink && googleReviewsUrl && (
            <Link
              href={googleReviewsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 font-sans text-[0.72rem] font-bold text-color-text-mid hover:text-primary transition-colors"
            >
              <GoogleIcon />
              {COPY.reviews.viewReviews}
            </Link>
          )}
        </div>
      )}
      {hasCarousel && (
        <div className="flex items-center gap-2">
          <button
            onClick={onPrev}
            aria-label={COPY.reviews.prevLabel}
            className="flex items-center justify-center w-10 h-10 border border-border tablet:border-transparent text-color-text-light hover:border-primary hover:text-primary hover:scale-110 transition-[transform,border-color,color] duration-200 cursor-pointer"
          >
            <ChevronIcon direction="left" />
          </button>
          <button
            onClick={onNext}
            aria-label={COPY.reviews.nextLabel}
            className="flex items-center justify-center w-10 h-10 border border-border tablet:border-transparent text-color-text-light hover:border-primary hover:text-primary hover:scale-110 transition-[transform,border-color,color] duration-200 cursor-pointer"
          >
            <ChevronIcon direction="right" />
          </button>
        </div>
      )}
    </div>
  );
}
